// extracted by mini-css-extract-plugin
export default {"loginPageImage":"loginPageImage_loginPageImage__qpn0u"};